import classNames from 'classnames/bind';
import styles from '../../Home.module.scss';
import {Fragment} from "react";
import { useAssetsImage } from "~/pages/context/AssetsImageContext";
import Skeleton from "react-loading-skeleton";

const cx = classNames.bind(styles);
function WelcomeToSession({screen, bodyEmphasis = true}){
    const { getImageUrlById, loading } = useAssetsImage();
    return (
        <section className={`${bodyEmphasis ? "bg-body-emphasis" : "bg-body"} pb-4 pt-0`} id="home">
            <div className="container-medium hero-header-container">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-auto order-0 order-md-1 text-end order-1">
                        <div className="position-relative p-5 p-md-7 d-lg-none">
                            <div className={cx("bg-holder-home", "bg-holder")}></div>
                                <div className="position-relative">
                                    {
                                        !loading &&
                                        <img src={getImageUrlById(17)} className="w-100 shadow-lg d-dark-none rounded-2" alt="Image"/>
                                    }
                                </div>
                            </div>
                        <div className="hero-image-container position-absolute top-0 bottom-0 end-0 d-none d-lg-block">
                            <div className="position-relative h-100 w-100">
                                {
                                    loading && <Skeleton height={20} containerClassName="welcome-session" />
                                }
                                {
                                    !loading && (
                                        <Fragment>
                                            <div className="position-absolute h-100 top-0 d-flex align-items-center end-0 hero-image-container-bg">
                                                <img src={getImageUrlById(5)} className="pt-7 pt-md-0 w-100" alt="Image"/>
                                            </div>
                                            <div className="position-absolute h-100 top-0 d-flex align-items-center end-0">
                                                <img src={getImageUrlById(14)} className="pt-7 pt-md-0 w-100 shadow-lg d-dark-none rounded-2" alt="Image"/>
                                            </div>
                                        </Fragment>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 text-lg-start text-center pt-8 pb-6 order-0 position-relative">
                        <h1 className="fs-4 fs-lg-3 fs-md-1 fs-lg-2 fs-xl-2 fs fw-black mb-4">
                            Welcome to
                            <span className="text-primary me-3"> BreakThrough AI Chatbot</span>
                        </h1>
                        <p className="mb-5">Only intelligent questions can stimulate, awaken, and enhance inner
                            human thinking, creativity, innovation, knowledge, and spiritual intelligence.
                        </p>
                        {
                            !screen && (
                                <Fragment>
                                    {
                                        !bodyEmphasis ?
                                        (
                                            <a className="btn btn-lg btn-primary rounded-pill me-3" href="/ai-chatbot/upgrade-plan" target="_blank">
                                                Start with your plan
                                            </a>
                                        )
                                        :
                                        (
                                            <a className="btn btn-lg btn-primary rounded-pill me-3" href="/ai-chatbot" target="_blank">
                                                Sign up to Chatbot
                                            </a>
                                        )
                                    }
                                </Fragment>
                            )
                        }
                        {
                            screen && (
                                <h1 className="text-primary">{screen}</h1>
                            )
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}
export default WelcomeToSession;